import { render } from "./StudentRequirementsDialog.vue?vue&type=template&id=791b0112&scoped=true"
import script from "./StudentRequirementsDialog.vue?vue&type=script&lang=js"
export * from "./StudentRequirementsDialog.vue?vue&type=script&lang=js"

import "./StudentRequirementsDialog.vue?vue&type=style&index=0&id=791b0112&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791b0112"]])

export default __exports__